module.exports = __webpack_public_path__ + "static/media/img3-1.79520f5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/soilcheck/rhumedad/img3-1.png
// module id = 1356
// module chunks = 3